var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIconThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#33AD73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.909 14L14.909 18L13.0908 16.1818",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 0V32H33V0H31Z",
    fill: "#EDF1F5",
    mask: "url(#path-1-inside-1_728_151)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIconThree);
export default __webpack_public_path__ + "static/media/report_icon_three.7e7c22776621a2303bef3a2c0545d479.svg";
export { ForwardRef as ReactComponent };